function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, "return": function _return(r) { var n = this.s["return"]; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, "throw": function _throw(r) { var n = this.s["return"]; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }
import { useCallback, useEffect, useReducer, useRef, useState } from 'react';
import { getCookie } from "../utils/cookie.mjs";
import { useAbortController } from "./useAbortController.mjs";
import { readEvents } from "../utils/server-sent-events.mjs";
import { CONTENT_FILTERED, CONVERSATION_RESET } from "../utils/message-status.mjs";
export var useMessages = function useMessages(_ref) {
  var endpoint = _ref.endpoint,
    lang = _ref.lang,
    idCookieName = _ref.idCookieName,
    _ref$stream = _ref.stream,
    stream = _ref$stream === void 0 ? false : _ref$stream;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    ready = _useState2[0],
    setReady = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var getHeaders = useCallback(
  /**
   * @param {HeadersInit} [headers]
   */
  function () {
    var headers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _headers = new Headers(headers);
    var token = getCookie(idCookieName);
    if (token) {
      _headers.set('Authorization', "Bearer ".concat(token));
    }
    return _headers;
  }, [idCookieName]);
  useEffect(function () {
    if (ready !== null) {
      return;
    }
    var controller = new AbortController();
    _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var accessEndpoint, body, token, res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            accessEndpoint = "".concat(endpoint, "/access");
            body = {};
            if (!idCookieName) {
              _context.next = 9;
              break;
            }
            token = getCookie(idCookieName);
            if (token) {
              _context.next = 8;
              break;
            }
            // If a cookie name was passed in and there is not a token in the cookie,
            // the user is not logged in. Don't show the chatbot.
            setReady(false);
            return _context.abrupt("return");
          case 8:
            body.token = token;
          case 9:
            _context.next = 11;
            return fetch(accessEndpoint, {
              method: 'POST',
              body: JSON.stringify(body),
              signal: controller.signal,
              headers: getHeaders({
                'Content-Type': 'application/json'
              })
            });
          case 11:
            res = _context.sent;
            setReady(res.ok);
            _context.next = 20;
            break;
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](0);
            if (!(_context.t0.name === 'AbortError')) {
              _context.next = 19;
              break;
            }
            return _context.abrupt("return");
          case 19:
            setReady(false);
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 15]]);
    }))();
    return function () {
      controller.abort();
    };
  }, [endpoint, getHeaders, idCookieName, ready]);
  var conversationId = useRef();
  var _useAbortController = useAbortController(),
    signal = _useAbortController.signal,
    abort = _useAbortController.abort;
  var _useReducer = useReducer(function (state, _ref3) {
      var role = _ref3.role,
        _ref3$content = _ref3.content,
        content = _ref3$content === void 0 ? '' : _ref3$content,
        status = _ref3.status,
        index = _ref3.index,
        _ref3$done = _ref3.done,
        done = _ref3$done === void 0 ? true : _ref3$done;
      if (!index) {
        return [].concat(_toConsumableArray(state), [{
          role: role,
          content: content,
          id: state.length,
          status: status,
          cid: conversationId.current,
          done: done
        }]);
      }
      var foundIndex = state.findIndex(function (message) {
        return message.index === index && message.cid === conversationId.current;
      });
      if (foundIndex === -1) {
        return [].concat(_toConsumableArray(state), [{
          role: role,
          content: content,
          id: state.length,
          index: index,
          cid: conversationId.current,
          done: done
        }]);
      }
      var found = state[foundIndex];
      return [].concat(_toConsumableArray(state.slice(0, foundIndex)), [_objectSpread(_objectSpread({}, found), {}, {
        content: found.content + content,
        done: done
      })], _toConsumableArray(state.slice(foundIndex + 1)));
    }, []),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    messages = _useReducer2[0],
    addMessage = _useReducer2[1];
  var sendMessage = useCallback(/*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(message) {
      var messageEndpoint, body, response, messageIdx, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step$value, cid, messageIndex, content, data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (message) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            addMessage({
              role: 'user',
              content: message
            });
            setLoading(true);
            messageEndpoint = conversationId.current ? "".concat(endpoint, "/chat/").concat(conversationId.current) : "".concat(endpoint, "/chat");
            body = {
              message: message,
              target: ['/manual/general-handbook'],
              lang: lang
            };
            _context2.prev = 6;
            _context2.next = 9;
            return fetch(messageEndpoint, {
              signal: signal,
              method: 'POST',
              body: JSON.stringify(body),
              headers: getHeaders({
                'Content-Type': 'application/json',
                Accept: stream ? 'text/event-stream' : 'application/json'
              })
            });
          case 9:
            response = _context2.sent;
            if (response.ok) {
              _context2.next = 14;
              break;
            }
            addMessage({
              status: response.status
            });
            if (response.status === CONTENT_FILTERED) {
              // content filter, reset conversation
              conversationId.current = undefined;
            }
            return _context2.abrupt("return");
          case 14:
            if (!stream) {
              _context2.next = 48;
              break;
            }
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context2.prev = 17;
            _iterator = _asyncIterator(readEvents(response.body, {
              signal: signal
            }));
          case 19:
            _context2.next = 21;
            return _iterator.next();
          case 21:
            if (!(_iteratorAbruptCompletion = !(_step = _context2.sent).done)) {
              _context2.next = 29;
              break;
            }
            _step$value = _step.value, cid = _step$value.conversationId, messageIndex = _step$value.messageIndex, content = _step$value.content;
            if (cid) {
              conversationId.current = cid;
            }
            if (messageIndex) {
              messageIdx = messageIndex;
            }
            if (content) {
              addMessage({
                role: 'assistant',
                content: content,
                index: messageIdx,
                done: false
              });
            }
          case 26:
            _iteratorAbruptCompletion = false;
            _context2.next = 19;
            break;
          case 29:
            _context2.next = 35;
            break;
          case 31:
            _context2.prev = 31;
            _context2.t0 = _context2["catch"](17);
            _didIteratorError = true;
            _iteratorError = _context2.t0;
          case 35:
            _context2.prev = 35;
            _context2.prev = 36;
            if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) {
              _context2.next = 40;
              break;
            }
            _context2.next = 40;
            return _iterator["return"]();
          case 40:
            _context2.prev = 40;
            if (!_didIteratorError) {
              _context2.next = 43;
              break;
            }
            throw _iteratorError;
          case 43:
            return _context2.finish(40);
          case 44:
            return _context2.finish(35);
          case 45:
            addMessage({
              index: messageIdx,
              done: true
            });
            _context2.next = 53;
            break;
          case 48:
            _context2.next = 50;
            return response.json();
          case 50:
            data = _context2.sent;
            if (data.conversationId) {
              conversationId.current = data.conversationId;
            }
            addMessage(_objectSpread(_objectSpread({}, data.message), {}, {
              // role, content
              index: data.messageIndex
            }));
          case 53:
            _context2.next = 61;
            break;
          case 55:
            _context2.prev = 55;
            _context2.t1 = _context2["catch"](6);
            if (!(_context2.t1.name === 'AbortError')) {
              _context2.next = 59;
              break;
            }
            return _context2.abrupt("return");
          case 59:
            console.error(_context2.t1);
            addMessage({
              status: 500
            });
          case 61:
            _context2.prev = 61;
            setLoading(false);
            return _context2.finish(61);
          case 64:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[6, 55, 61, 64], [17, 31, 35, 45], [36,, 40, 44]]);
    }));
    return function (_x) {
      return _ref4.apply(this, arguments);
    };
  }(), [endpoint, getHeaders, lang, signal, stream]);
  var resetConversation = useCallback(function () {
    abort();
    conversationId.current = undefined;
    setLoading(false);
    addMessage({
      status: CONVERSATION_RESET
    });
  }, [abort]);
  var sendFeedback = useCallback(/*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref5, feedback) {
      var cid, index, feedbackEndpoint, response;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            cid = _ref5.cid, index = _ref5.index;
            feedbackEndpoint = "".concat(endpoint, "/chat/").concat(cid, "/feedback/").concat(index);
            _context3.prev = 2;
            _context3.next = 5;
            return fetch(feedbackEndpoint, {
              method: 'PUT',
              body: JSON.stringify(feedback),
              headers: getHeaders({
                'Content-Type': 'application/json'
              })
            });
          case 5:
            response = _context3.sent;
            return _context3.abrupt("return", response.status === 200);
          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](2);
            return _context3.abrupt("return", false);
          case 12:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[2, 9]]);
    }));
    return function (_x2, _x3) {
      return _ref6.apply(this, arguments);
    };
  }(), [endpoint, getHeaders]);
  return {
    ready: ready,
    loading: loading,
    messages: messages,
    conversationId: conversationId.current,
    sendMessage: sendMessage,
    resetConversation: resetConversation,
    sendFeedback: sendFeedback
  };
};